import React, { useEffect, useRef, useState } from "react";
import useSearch from "hooks/useSearch";
import { ReactComponent as OpenMapIcon } from "assets/icons/open_map.svg";
import { ReactComponent as DrawMapIcon } from "assets/icons/draw_map.svg";
import { ReactComponent as LocationIcon } from "assets/icons/location.svg";
import { useNavigate } from "react-router";
import { formatLocationName, isObjectEmpty } from "utils/commonUtils";

const SearchDropdown = ({ dropdonwStyle }) => {
  const {
    searchTerm,
    showSearchDropdown,
    setShowSearchDropdown,
    handleSearchChange,
    handleSelectLocation,
    closeSearchDropdown,
    searchResults,
    searchLoading,
    selectedLocations,
  } = useSearch();
  const dropdownRef = useRef(null);
  const inputRef = useRef(null); // Ref for the input field
  const navigation = useNavigate();
  const [focusedMap, setFocusedMap] = useState("polygonMap");
  const [focusedLocation, setFocusedLocation] = useState("");

  // Hide dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeSearchDropdown();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  // auto focus input
  useEffect(() => {
    if (showSearchDropdown && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showSearchDropdown]);

  useEffect(() => {
    setFocusedLocation("");
  }, [searchTerm]);

  return (
    <div
      style={dropdonwStyle}
      ref={dropdownRef}
      className={` ${
        showSearchDropdown ? "search-filter-dropdown-active" : "hidden"
      } rounded-bl-[10px] rounded-br-[10px] md:rounded-bl-[20px] bg-white md:rounded-br-[20px] w-full search-dropdown-shadow overflow-hidden absolute top-[68.3px] left-0 right-0`}
    >
      {searchTerm && showSearchDropdown && (
        <ul className="bg-white rounded-bl-[10px] md:rounded-bl-[20px] rounded-br-[10px] md:rounded-br-[20px] max-h-[300px] md:max-h-[500px] overflow-y-auto list-none">
          {!searchLoading && searchResults.length > 0 ? (
            searchResults.map((location, index) => {
              return (
                <p
                  onMouseEnter={() => setFocusedLocation(location.id)}
                  key={location.id}
                  className="flex items-center space-x-[15px] px-3 md:px-5 cursor-pointer h-[40px] md:h-[70px]  hover:bg-[#D9D9D94D] transition-all duration-200 ease-in-out overflow-hidden"
                  style={{
                    backgroundColor:
                      focusedLocation === location.id ||
                      (focusedLocation === "" && index === 0)
                        ? "#D9D9D94D"
                        : "white",
                  }}
                  onClick={() => handleSelectLocation(location)}
                >
                  <LocationIcon className="w-[28px] h-[28px]" />
                  <li
                    className="truncate leading-[1.2] text-[16px] font-extralight text-[#3C0A0A] md:text-[20px] overflow-hidden"
                    key={location.zip}
                  >
                    {formatLocationName(location.name)}
                  </li>
                </p>
              );
            })
          ) : (
            // Search loading
            <li className="text-[#3C0A0A] h-[70px] px-[23px] flex flex-col justify-center leading-[1.2] text-[20px] cursor-pointer hover:bg-[#D9D9D94D] transition-all duration-200 ease-in-out">
              {searchLoading ? (
                <div className="flex items-center space-x-3">
                  <div>
                    <svg
                      aria-hidden="true"
                      className="inline w-8 h-8 text-gray-200 animate-spin fill-primary"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <span className="sr-only">Caricamento...</span>
                  </div>
                  <p className="text-[20px] font-extralight text-[#3C0A0A]">
                    Caricamento...
                  </p>
                </div>
              ) : (
                "Nessun risultato"
              )}
            </li>
          )}
        </ul>
      )}
      {/* Map butons when there is nothing typed */}
      {!searchTerm && selectedLocations.length < 1 && (
        <div className="">
          <ul className="">
            <li
              onMouseEnter={() => setFocusedMap("polygonMap")}
              onClick={() => navigation("/map")}
              className="h-[82px] cursor-pointer px-[15px] flex items-center space-x-2 hover:bg-[#D9D9D94D] transition-all duration-200"
              style={{
                backgroundColor:
                  focusedMap === "polygonMap" ? "#D9D9D94D" : "white",
              }}
            >
              <OpenMapIcon className="w-[47px] h-[49px]" />
              <div>
                <h3 className="text-primary font-semibold text-[16px] sm:text-[20px]">
                  Apri mappa e seleziona
                </h3>
                <p className="font-medium text-[12px] sm:text-[16px] text-[#B2B2B2]">
                  Seleziona su mappa provincia, comune o zone
                </p>
              </div>
            </li>
            <li
              onMouseEnter={() => setFocusedMap("drawMap")}
              onClick={() => navigation("/map?mapType=draw")}
              className="h-[82px] cursor-pointer px-[15px] flex items-center space-x-2 hover:bg-[#D9D9D94D] transition-all duration-200"
              style={{
                backgroundColor:
                  focusedMap === "drawMap" ? "#D9D9D94D" : "white",
              }}
            >
              <DrawMapIcon className="w-[45px] h-[45px]" />
              <div>
                <h3 className="text-primary font-semibold text-[16px] sm:text-[20px]">
                  Disegna area su mappa
                </h3>
                <p className="font-medium text-[12px] sm:text-[16px] text-[#B2B2B2]">
                  Disegna su mappa l'area dove vuoi cercare
                </p>
              </div>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;
